import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../assets/logo.png';
import svFlag from '../assets/flag-sv.png';
import viFlag from '../assets/flag-vi.png';

const Header = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navLinks = [
    { label: t('menu.servicesoverview'), to: '/services-overview' },
    { label: t('menu.contact'), to: '/contact' },
    { label: t('menu.aboutcompany'), to: '/about-company' }
  ];

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
          py: 1.5
        }}
      >
        {isMobile ? (
          <IconButton onClick={handleDrawerToggle} sx={{ color: '#c6a04c' }}>
            <MenuIcon />
          </IconButton>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 2,
              justifyContent: 'center',
              flexGrow: 1,
              textTransform: 'uppercase'
            }}
          >
            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover img': {
                  transform: 'scale(1.1)',
                  boxShadow: '0 0 10px #c6a04c',
                  borderRadius: '8px'
                }
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                  height: 60,
                  transition: 'all 0.2s ease-in-out',
                  mr: 5
                }}
              />
            </Box>

            {navLinks.map((item, index) => (
              <Button
                key={index}
                component={RouterLink}
                to={item.to}
                sx={{
                  color: '#c6a04c',
                  fontWeight: 600,
                  '&:hover': {
                    borderBottom: '2px solid #c6a04c',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={() => changeLanguage('sv')} sx={{ p: 0 }}>
            <Box
              component="img"
              src={svFlag}
              alt="Svenska"
              sx={{
                width: 28,
                borderRadius: '50%',
                boxShadow: '0 0 5px #c6a04c',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.2)',
                  boxShadow: '0 0 10px #c6a04c'
                }
              }}
            />
          </IconButton>

          <IconButton onClick={() => changeLanguage('vi')} sx={{ p: 0 }}>
            <Box
              component="img"
              src={viFlag}
              alt="Tiếng Việt"
              sx={{
                width: 28,
                borderRadius: '50%',
                boxShadow: '0 0 5px #c6a04c',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.2)',
                  boxShadow: '0 0 10px #c6a04c'
                }
              }}
            />
          </IconButton>
        </Box>
      </Toolbar>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#0f111a',
            color: '#c6a04c',
            width: 250
          }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <IconButton onClick={handleDrawerToggle} sx={{ color: '#c6a04c' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {navLinks.map((item, index) => (
            <ListItemButton
              key={index}
              component={RouterLink}
              to={item.to}
              onClick={handleDrawerToggle}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Header;
